var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.processing)?_c('div',{staticClass:"center1",class:{ 'spinner' : _vm.processing },style:({ 'border-top-color': _vm.color, width: _vm.size, height: _vm.size })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }